import { render, staticRenderFns } from "./RestricaoVenda.vue?vue&type=template&id=56b823b8"
import script from "./RestricaoVenda.vue?vue&type=script&lang=js"
export * from "./RestricaoVenda.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports